import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import { RecoilRoot } from 'recoil';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// disable console log in production mode
if (import.meta.env.MODE !== 'development') {
    console.log = () => {};
}

// mark the environment in the tab title: staging (admin-staging.goldblack.net, *-staging.pages.dev) or prod; none on localhost
const { hostname } = window.location;
if (hostname.includes('staging')) {
    document.title += ' - staging';
} else if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    document.title += ' - prod';
}

// reload once when a stale deployment's chunk is gone (server falls back to index.html)
window.addEventListener('vite:preloadError', () => {
    if (!sessionStorage.getItem('chunk-reloaded')) {
        sessionStorage.setItem('chunk-reloaded', '1');
        window.location.reload();
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RecoilRoot>
        <App />
    </RecoilRoot>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
